import React from 'react';

interface MembershipCheckboxProps {
    isMember: boolean;
    onChange: (isMember: boolean) => void;
}

const MembershipCheckbox: React.FC<MembershipCheckboxProps> = ({ isMember, onChange }) => {
    return (
        <div>
            <label className="font-medium text-gray-700 flex items-start">
                <input
                    id="is-member"
                    name="is_member"
                    type="checkbox"
                    checked={isMember}
                    onChange={(e) => onChange(e.target.checked)}
                    className="mr-2 mt-2"
                />
                <div>
                    I'm an ACA member
                    <span className="block text-sm font-light italic">
                        ACA is self-supporting and can only accept donations from members
                    </span>
                </div>
            </label>
        </div>
    );
};

export default MembershipCheckbox;
